import {
  PURCHASABLE,
  INSTORE_ONLY,
  MAX_ONLY,
  TRADE_ACCOUNT_ONLY,
  CREATIVE_GLASS_ONLY,
  ENQUIRE_ONLY,
  NOT_AVAILABLE
} from "./PurchaseControlTypes";

const PurchaseControl = ({
  type,
  renderPurchasable,
  renderInstoreOnly,
  renderMaxOnly,
  renderEnquireOnly,
  renderCreativeGlassOnly,
  renderTradeAccountOnly,
  renderNotAvailableOnly,
  children
}) => {
  switch (type) {
    case PURCHASABLE:
      return renderPurchasable();

    case INSTORE_ONLY:
      return renderInstoreOnly();

    case MAX_ONLY:
      return renderMaxOnly();

    case ENQUIRE_ONLY:
      return renderEnquireOnly();

    case CREATIVE_GLASS_ONLY:
      return renderCreativeGlassOnly();

    case TRADE_ACCOUNT_ONLY:
      return renderTradeAccountOnly();

    case NOT_AVAILABLE:
      return renderNotAvailableOnly();

    default:
      return children || false;
  }
};

export default PurchaseControl;
